"use client";

import React, { createContext, useContext, useState, ReactNode } from "react";

export enum ModalType {
  CAMERA_PERMISSION = "CAMERA_PERMISSION",
  WRONG_LABEL = "WRONG_LABEL",
}

interface ModalContextType {
  openModals: Record<ModalType, boolean>;

  openModal: (modalType: ModalType) => void;
  closeModal: (modalType: ModalType) => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [openModals, setOpenModals] = useState<Record<ModalType, boolean>>(
    () => {
      const initialState: Record<ModalType, boolean> = {} as Record<
        ModalType,
        boolean
      >;
      Object.values(ModalType).forEach((type) => {
        initialState[type as ModalType] = false;
      });
      return initialState;
    },
  );

  const openModal = (modalType: ModalType) => {
    setOpenModals((prev) => ({
      ...prev,
      [modalType]: true,
    }));
  };

  const closeModal = (modalType: ModalType) => {
    setOpenModals((prev) => ({
      ...prev,
      [modalType]: false,
    }));
  };

  const value = {
    openModals,
    openModal,
    closeModal,
  };

  return (
    <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
  );
};

export const useModal = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error("useModal debe ser usado dentro de un ModalProvider");
  }
  return context;
};
